import BaseApi from './BaseApi'

class WorkInProgressAdviserProfilesApi extends BaseApi {

  get workInProgressAdviserProfilesUrl () {
    return 'adviserProfilesWorkInProgress'
  }

  getWorkInProgressAdviserProfile (adviserId) {
    return this.getJson(`${this.workInProgressAdviserProfilesUrl}/${adviserId}`)
  }

  updateWorkInProgressAdviserProfile (adviserId, profile) {
    return this.putJson(`${this.workInProgressAdviserProfilesUrl}/${adviserId}`, profile)
  }

  updateLanguagePreferences (adviserId, profile) {
    return this.putJson(`${this.workInProgressAdviserProfilesUrl}/${adviserId}/languages`, profile)
  }

  updateClientTypes (adviserId, profile) {
    return this.putJson(`${this.workInProgressAdviserProfilesUrl}/${adviserId}/clientTypes`, profile)
  }

  updateAreasOfSpecialisation (adviserId, profile) {
    return this.putJson(`${this.workInProgressAdviserProfilesUrl}/${adviserId}/specialisations`, profile)
  }

  updateConflictDeclarations (adviserId, profile) {
    return this.putJson(`${this.workInProgressAdviserProfilesUrl}/${adviserId}/conflictDeclarations`, profile)
  }

  updateEducation (adviserId, profile) {
    return this.putJson(`${this.workInProgressAdviserProfilesUrl}/${adviserId}/qualifications`, profile)
  }

  updateContactNumbers (adviserId, profile) {
    return this.putJson(`${this.workInProgressAdviserProfilesUrl}/${adviserId}/contactNumbers`, profile)
  }

  updatePublicContactEmailAddress (adviserId, profile) {
    return this.putJson(`${this.workInProgressAdviserProfilesUrl}/${adviserId}/publicContactEmailAddress`, profile)
  }

  updateProfilePicture (adviserId, profile) {
    return this.putJson(`${this.workInProgressAdviserProfilesUrl}/${adviserId}/profilePicture`, profile)
  }

  updateCompanyLogo (adviserId, profile) {
    return this.putJson(`${this.workInProgressAdviserProfilesUrl}/${adviserId}/companyLogo`, profile)
  }

  updateInvestmentMinimums (adviserId, profile) {
    return this.putJson(`${this.workInProgressAdviserProfilesUrl}/${adviserId}/investmentMinimums`, profile)
  }

  updateEducationQualifications (adviserId, profile) {
    return this.putJson(`${this.workInProgressAdviserProfilesUrl}/${adviserId}/qualifications`, profile)
  }

  updateWorkExperiences (adviserId, profile) {
    return this.putJson(`${this.workInProgressAdviserProfilesUrl}/${adviserId}/workExperiences`, profile)
  }
}
export default WorkInProgressAdviserProfilesApi
